import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";

class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <SEO
          title={
            "On demand truck and driver hire transportation service. Local truck/bakkie hire and couriers at affordable prices."
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Move your goods with our delivery vehicles and drivers. Furniture, Equipment, Construction Materials and more! Review your instant online quotation now. On demand truck and driver hire transportation service."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/investors"}
          twitterUsername={"qiktrucksa"}
        />
        <section id="home">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <h1>
                  QikTruck: <span className="orange">Insurance</span>
                  <span className="green">on-demand</span>
                </h1>
                <br />
                <br />
                <h2>Our commitment:</h2>
                <p>
                  At QikTruck, we understand that commercial insurance and proper risk management are fundamental to modern logistics. As a transportation platform that connects customers with independent transport providers across South Africa, we are committed to supporting the safe movement of goods through responsible handling, transparent value declaration, and optional Goods in Transit (GIT) insurance.
                </p>

                <h4>Commercial auto insurance:</h4>
                <p>
                  Transport providers operating on the QikTruck platform are responsible for maintaining commercial vehicle insurance and regulatory compliance for their vehicles. This ensures that professional transport providers are appropriately insured for the commercial use of their vehicles and helps maintain industry standards for reliability and continuity during operations.
                </p>

                <h4>Goods in Transit (GIT) insurance:</h4>
                <p>
                  GIT insurance protects goods while they are being transported against loss, damage, or theft. For many businesses, contractors, retailers, and field-service companies, GIT coverage is an essential part of moving valuable items, equipment, furniture, construction materials, solar components, or retail stock.
                </p>
                <p>
                  At QikTruck, we support optional GIT insurance to help safeguard goods during collection, loading, transit, and delivery. When enabled, GIT coverage applies from the moment goods are handed over to the transport provider until delivery is completed and confirmed.
                </p>

                <h4>Declared value and acceptance:</h4>
                <p>
                  To ensure proper protection, goods must be correctly declared at the time of booking. The declared value helps determine whether GIT insurance applies and enables transport providers to verify and accept the job on accurate terms. During acceptance of a trip, carriers may verify the declared value and condition of goods, and GIT may be updated accordingly before pickup.
                </p>

                <h5>Why GIT insurance matters for QikTruck customers and partners:</h5>
                <ul>
                  <li>
                    <strong>Comprehensive protection:</strong> GIT can cover loss, damage, and theft while goods are in custody of the transport provider, including during loading and unloading when applicable.
                  </li>
                  <li>
                    <strong>Trust and transparency:</strong> Declared value and optional insurance create confidence for customers moving valuable cargo and help align expectations between shipper and carrier.
                  </li>
                  <li>
                    <strong>Financial protection:</strong> GIT insurance reduces financial exposure for businesses moving inventory, equipment, or goods that form part of operational continuity.
                  </li>
                  <li>
                    <strong>Contractual compliance:</strong> Many commercial agreements, procurement policies, and enterprise deliveries require GIT coverage as standard. QikTruck supports those requirements through insurance-on-demand workflows.
                  </li>
                  <li>
                    <strong>Flexible protection:</strong> Not all deliveries carry the same value or risk. GIT enables coverage to be tailored according to declared value, commodity type, and operational needs.
                  </li>
                </ul>

                <h5>Roles and responsibilities:</h5>
                <p>
                  QikTruck operates as a transportation network platform. We do not own vehicles or act as a carrier. Each transport service is performed by an independent transport provider who assumes responsibility for the goods while in their custody. Customers are responsible for accurately declaring the nature and value of goods and for providing lawful and suitably packaged items for transport.
                </p>

                <h5>Insurance facilitation:</h5>
                <p>
                  QikTruck is not an insurer. When GIT insurance is selected or contractually required, coverage is underwritten by licensed insurers. QikTruck may facilitate policy workflows, declared value, and claims submissions as part of our platform experience.
                </p>

                <h5>Our continuing commitment:</h5>
                <p>
                  QikTruck remains committed to advancing safety, transparency, and operational excellence across the logistics ecosystem. As commercial logistics and supply chains evolve, so does the importance of responsible insurance practices, digital booking transparency, and proper risk allocation between shipper, carrier, and insurer. Through declared value logistics and insurance-on-demand, we aim to create a modern, reliable, and trusted environment for businesses and consumers moving goods with QikTruck.
                </p>
                
                <p>
                  For more information or enterprise insurance requests, contact: <a href="mailto:support@qiktruck.co.za"><b>support@qiktruck.co.za</b></a>
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
